export default String.raw`
.companies {
    width: 100%;
    user-select: none;
    padding: 0 9%;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        a {
            display: flex;
            align-items: center;
            margin-right: 60px;
            @include button;

            svg {
                margin-left: 4px;
                width: 16px;
                height: 16px;
            }
        }
    }

    &__container {
        position: relative;
    }

    &__swiper {
        overflow-x: hidden;
        height: 200px;

        .swiper-button-pause {
            top: -55px;
            box-shadow: unset;
        }
    }

    &__wrapper {
        height: 100%;
        align-items: center;
    }

    &__slide {
        display: flex !important;
        justify-content: center;
        width: calc(100% / 8.5);
        padding: 3px;

        a {
            div {
                @include body-1-regular;
                color: $primaryColorFont;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: fit-content;
                height: 100%;

                img {
                    max-width: 100%;
                    max-height: calc(100% - 2lh);
                    object-fit: cover;
                    border-radius: 8px;
                }

                span {
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    text-align: center;
                    word-wrap: break-word;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    visibility: hidden;
                    padding: 4px 8px;
                    background-color: #F8F9FA;
                }

                &:hover {
                    span {
                        visibility: visible;
                    }
                }
            }
        }
    }

    &__prev, &__next {
        position: absolute;
        z-index: 90;
        top: calc(50% - 24px);

        svg {
            width: 16px;
            height: 16px;
        }
    }

    &__prev {
        left: -59px;

        svg {
            rotate: 180deg;
        }
    }

    &__next {
        right: -59px;
    }
}
`